// extracted by mini-css-extract-plugin
export default {"container":"newsletter_container__+i8uJ","send-email-group":"newsletter_send-email-group__Ti5Zb"};